import { h, t, T, domWithScope } from '@jsx6/jsx6'

/**
 * 
 * @param {Element} logo 
 * @param {ChatBox} chat 
 * @returns 
 */
export const unavailableChat = (chat) => {
  return (
    <div p="area.unavailableChat" hidden>
      <div class="end-message">
        <span p="endMsg">{chat.$s.unavailableMsg}</span>
      </div>
      {chat.$s.logo}
    </div>
  )
}